export enum FontCategories {
    display = "Display",
    handwriting = "Hand Writing",
    monospace = "Mono Space",
    'sans-serif' = "Sans Serif",
    'serif' = "Serif",
}